import React from 'react';
import {
	BackArrow,
	ThreadsLogo,
	Close
} from '../../Icons';

import FormBuilder from './FormBuilder';

// import Slide from 'react-reveal/Slide';
// import Fade from 'react-reveal/Fade';

import { formatPriceDollars } from '../../Helpers';

export const ProgressBar = (props) => {
	const styles = {
		'width': `${props.progress}%`,
		'marginRight': `${100 - props.progress}%`
	};
	return (
		// <Slide left delay={100}>
			<div className="BoxBuilder_ProgressBar" style={styles}></div>
		// </Slide>
	)
}

export const Header = (props) => {
	return (
		<div className="BoxBuilder_Header">
			{props.currentStepIndex > 0 ? (
				<span onClick={props.handleBackStep}><BackArrow /> <strong>Back</strong></span>
			) : (
					<span></span>
				)
			}

			<span><ThreadsLogo /></span>
			<span onClick={props.handleConfirmationModal}><strong>Exit</strong> <Close /></span>
		</div>
	)
}

export const BottomBar = (props) => {

	return (
		// <Fade big delay={600}>
			<div className="BoxBuilder_BottomBar">
				<div>
					<strong>Total:{formatPriceDollars(props.totalNoTax)}</strong>
					{props.totalNoTax !== props.totalNoDiscount &&
						<span>{formatPriceDollars(props.totalNoDiscount)}</span>
					}
				</div>
				{props.hasNextButton &&
					<React.Fragment>
						{props.buttonActive ? (
							<button className="button" onClick={props.handleNextStep}>Next Step</button>
						) : (
								<button className="button disabled">Next Step</button>
							)}
					</React.Fragment>
				}
				{props.hasCheckoutButton &&
					<FormBuilder
						{...props}
					/>
				}


			</div>
		// </Fade>
	)
}

export const Title = (props) => {
	return (
		<h2 className="BoxBuilder_Title">{props.title}</h2>
	)
}

export const ConfirmationModal = (props) => <div className="BoxBuilder_ConfirmationModal">
	<div className="modal">
		<Title title="Are you sure?" />
		<p>You're almost there. If you close this you’ll have to start again from the beginning.</p>
		<button className="button" onClick={props.handleConfirmationModal}>Nevermind</button>
		<a className="button light" href="https://www.yourthreads.co/pages/plans">I will come back later</a>
	</div>
</div>